import React, { useCallback, useMemo, useRef, useState } from "react"
import { Container, Grid, Chip } from "@material-ui/core"
import { useHistory } from "react-router";
import { DataGrid } from '@material-ui/data-grid';
import { useMutation, useQuery } from "react-query";
import { fetchAllExperts, chatWithExpert, fetchServices, fetchCountries, fetchNiches, fetchCityByCountry } from "../services"
import TableContainerServerSide from "../components/TableContainerServerSide"
import Select from "react-select"
import { Button } from "../components/button"
import { OpenInNew, StarOutline } from '@material-ui/icons';
import StarFilled from '@material-ui/icons/Star'
import { Rating } from '@mui/material'
import SelectColumnFilter from "../components/SelectFilter"
import DefaultFilter from "../components/DefaultFilter"
import moment from 'moment';
import { AddAgencyModal } from "../components/AddAgencyModal";
import { useAuth } from "../utils/Auth";
import { SendMoneyModal } from "../components/SendMoneyModal";
import TopEarnersModal from "../components/TopEarnersModal";

function CountryFilter({
    column: { filterValue, setFilter, preFilteredRows, id, FilterOptions, onCountryChange },
}) {
    const options = useMemo(() => {
        return FilterOptions || []
    }, [FilterOptions])

    return (
        <div style={{ width: 180, zIndex: 10000 }}>
            <Select
                value={filterValue ? options.find(o => o.value === filterValue) : null}
                styles={{
                    menu: provided => ({ ...provided, zIndex: 9999 })
                }}
                onChange={(selectedOption) => {
                    const value = selectedOption?.value;

                    setFilter(value || undefined);
                    if (value) {
                        sessionStorage.setItem(id, value);
                    } else {
                        sessionStorage.removeItem(id);
                    }

                    // Call onCountryChange if it exists
                    if (onCountryChange && typeof onCountryChange === 'function') {
                        onCountryChange(value);
                    }
                }}
                options={options}
            />
        </div>
    )
}

function Ugc() {
    const { user } = useAuth()
    const isReadOnly = user?.email === process.env.REACT_APP_SALMAN_ADMIN_EMAIL
    const history = useHistory()
    const [total, setTotal] = useState(0)
    const [pageCount, setPageCount] = useState(1)
    const [countryId, setCountryId] = useState(null)
    const [experts, setExperts] = useState([])
    const [agencyModalOpen, setAgencyModalOpen] = useState(false)
    const [sendMoneyModalOpen, setSendMoneyModalOpen] = useState(false)
    const [topEarnersModalOpen, setTopEarnersModalOpen] = useState(false)
    const request = useRef()

    const { data: serviceOptions } = useQuery('services', () => fetchServices(), {
        select: res => res.services.map(e => e.name),
        refetchOnWindowFocus: false,
    })

    const { data: countries = [], isCountryLoading } = useQuery('countries', () => fetchCountries('only_available=true'), {
        select: data => data.countries.map(e => ({ value: e.name, label: e.name, id: e.id })),
        refetchOnWindowFocus: false,
    })

    const handleCountryChange = useCallback((countryName) => {
        if (countryName && countries) {
            const country = countries.find(c => c.value === countryName);

            if (country) {
                setCountryId(country.id);
            } else {
                setCountryId(null);
            }
        } else {
            setCountryId(null);
        }
    }, [countries])

    const { data: cities = [], isCityLoading } = useQuery(['cities', countryId], () => fetchCityByCountry(countryId), {
        select: data => data.cities.map(e => ({ value: e.name, label: e.name })),
        refetchOnWindowFocus: false,
        enabled: !!countryId,
    })

    const { data: niches = [], isNichesLoading } = useQuery('niches', () => fetchNiches(), {
        select: data => data.niches.map(e => ({ value: e.name, label: e.name })),
        refetchOnWindowFocus: false,
    })

    const columns = useMemo(() => [
        {
            Header: 'Name',
            id: 'name',
            accessor: ({ name, signin_method, uid }) => {
                return (
                    <div style={{ cursor: 'pointer', color: 'blue' }} onClick={() => {
                        window.open(`${process.env.REACT_APP_STLLR_URL}creators/${uid}`, '_blank')
                    }}>
                        {name}{signin_method === 'google'
                            ? ' (G)'
                            : signin_method === 'linkedin'
                                ? ' (L)'
                                : ''
                        }
                    </div>
                )
            },
            Filter: DefaultFilter,
            show: false
        },
        {
            Header: 'Email',
            id: 'email',
            accessor: `email`,
            Filter: DefaultFilter,
            // show: false
        },
        {
            Header: 'Username',
            id: 'uid',
            accessor: `uid`,
            // Filter: DefaultFilter,
            // show: false
            disableFilters: true
        },
        {
            Header: 'Profile completed',
            id: 'is_profile_completed_str',
            accessor: `is_profile_completed_str`,
            Filter: SelectColumnFilter,
            FilterOptions: ['Yes', 'No'],
        },
        {
            Header: 'Phone number',
            id: 'phone_number',
            accessor: `phone_number`,
            Filter: DefaultFilter,
            show: false
        },
        {
            Header: 'Signed up on',
            id: 'date_add',
            accessor: ({ date_add }) => {
                return moment(date_add).format('LL')
            },
            disableFilters: true
        },
        // {
        //     Header: 'Services',
        //     id: 'services',
        //     accessor: ({ services }) => {
        //         return services.map(s => {
        //             return s.service_name
        //         })
        //     },
        //     Cell: ({ row }) => {
        //         let { services } = row.original

        //         return services.map(as => {
        //             return <div className="service-chip">{as.service_name}</div>
        //         })
        //     },
        //     disableFilters: true
        // },
        {
            Header: 'Language',
            id: 'languages',
            accessor: ({ languages }) => {
                return languages.map(i => {
                    return i.name
                })
            },
            Cell: ({ row }) => {
                let { languages } = row.original

                return languages.map(as => {
                    return <div className="service-chip">{as.name}</div>
                })
            },
            Filter: DefaultFilter,
            minWidth: 700,
        },
        // {
        //     Header: 'Industries',
        //     id: 'industries',
        //     accessor: ({ industries }) => {
        //         return industries.map(i => {
        //             return i.name
        //         })
        //     },
        //     Cell: ({ row }) => {
        //         let { industries } = row.original

        //         return industries.map(as => {
        //             return <div className="service-chip">{as.name}</div>
        //         })
        //     },
        //     disableFilters: true
        // },
        // {
        //     Header: 'Sectors',
        //     id: 'sectors',
        //     accessor: ({ sectors }) => {
        //         return sectors.map(i => {
        //             return i.name
        //         })
        //     },
        //     Cell: ({ row }) => {
        //         let { sectors } = row.original

        //         return sectors.map(as => {
        //             return <div className="service-chip">{as.name}</div>
        //         })
        //     },
        //     disableFilters: true
        // },
        {
            Header: 'Country',
            id: 'country_name',
            accessor: 'country_name',
            Filter: (props) => <CountryFilter {...props} column={{ ...props.column, onCountryChange: handleCountryChange }} />,
            FilterOptions: user.email === process.env.REACT_APP_NOUR_ADMIN_EMAIL ? countries.filter(e => e.value === "Egypt") : countries,
        },
        {
            Header: 'City',
            id: 'city_name',
            accessor: 'city_name',
            // Filter: DefaultFilter,
            Filter: SelectColumnFilter,
            FilterOptions: cities,
        },
        {
            Header: 'Niche',
            id: 'niche_name',
            accessor: 'niche_name',
            Filter: SelectColumnFilter,
            FilterOptions: niches,
        },
        {
            Header: 'Show Face',
            id: 'is_show_face_str',
            accessor: 'is_show_face_str',
            Filter: SelectColumnFilter,
            FilterOptions: ['Yes', 'No'],
            Cell: ({ cell }) => {
                return !cell.value ? 'N/A' : <Chip size="small" className={`chip-${cell.value.toLowerCase() === "yes" ? `green` : `red`}`} label={cell.value.toLowerCase() === "yes" ? `Yes` : `No`} />
            }
        },
        {
            Header: 'Gender',
            id: 'gender',
            accessor: 'gender',
            Filter: SelectColumnFilter,
            FilterOptions: [{ label: 'Male', value: 'm' }, { label: 'Female', value: 'f' }],
        },
        {
            Header: '# approved videos',
            id: 'n_videos_approved',
            accessor: 'n_videos_approved',
            disableFilters: true
        },
        {
            Header: 'Total earnings',
            id: 'total_earnings',
            accessor: 'total_earnings',
            disableFilters: true,
            isSortable: true,
            sortType: 'number',
            Cell: ({ cell }) => {
                return !cell.value ? 'N/A' : <div>${cell.value}</div>
            }
        },
        {
            Header: 'Avg SLA',
            id: 'avg_sla',
            accessor: 'avg_sla',
            disableFilters: true,
            Cell: ({ cell }) => {
                return !cell.value ? 'N/A' : <div>{cell.value} days</div>
            }
        },
        {
            Header: 'Has Mawthooq',
            id: 'has_mawthooq_str',
            accessor: 'has_mawthooq_str',
            Filter: SelectColumnFilter,
            FilterOptions: ['Yes', 'No'],
            Cell: ({ cell }) => {
                return !cell.value ? 'N/A' : <Chip size="small" className={`chip-${cell.value.toLowerCase() === "yes" ? `green` : `red`}`} label={cell.value.toLowerCase() === "yes" ? `Yes` : `No`} />
            },
            showColumn: false
        },
        {
            Header: 'Social username/url',
            id: 'social_urls',
            accessor: ({ tiktok_url, youtube_url, instagram_url, twitter_url, behance_url, imdb_url, dribbble_url }) => {
                return [tiktok_url, youtube_url, instagram_url, twitter_url, behance_url, imdb_url, dribbble_url]
                    .filter(url => url)
                    .join(' ');
            },
            Filter: DefaultFilter,
            showColumn: false
        },
        {
            Header: 'Nano Creator',
            id: 'is_nano_str',
            accessor: 'is_nano',
            Filter: SelectColumnFilter,
            FilterOptions: ['Yes', 'No'],
            // disableFilters: true,
            Cell: ({ row }) => {
                const { is_nano } = row.original;
                return <Chip size="small" className={`chip-${is_nano === 1 ? `green` : `red`}`} label={is_nano === 1 ? `Yes` : `No`} />
            }
        },
        {
            Header: 'Social',
            disableFilters: true,
            Cell: ({ row }) => {
                const { tiktok_url, youtube_url, instagram_url, twitter_url, behance_url, imdb_url, dribbble_url, portfolio_link } = row.original;
                return <div className="is-flex aic">
                    {tiktok_url && <a href={tiktok_url} target="_blank" rel="noopener noreferrer">
                        <img src="/tiktok-icon-32.png" className="mr-5" alt="tiktok" width="24" />
                    </a>}
                    {youtube_url && <a href={youtube_url} target="_blank" rel="noopener noreferrer">
                        <img src="/youtube-icon-32.png" className="mr-5" alt="youtube" width="24" />
                    </a>}
                    {instagram_url && <a href={instagram_url} target="_blank" rel="noopener noreferrer">
                        <img src="/instagram-icon-32.png" className="mr-5" alt="instagram" width="24" />
                    </a>}
                    {twitter_url && <a href={twitter_url} target="_blank" rel="noopener noreferrer">
                        <img src="/x-icon-32-cropped.png" className="mr-5" alt="twitter" width="24" />
                    </a>}
                </div>
            }
        },
        // {
        //     Header: `Rating`,
        //     // disableFilters: true,
        //     accessor: `rating_sort`,
        //     Cell: ({ row }) => {
        //         const { avg_rating, n_reviews } = row.original;
        //         return (
        //             <div className="is-flex fdr">
        //                 <Rating
        //                     // name="communication"
        //                     defaultValue={avg_rating}
        //                     icon={<StarFilled style={{ color: '#fcbb08' }} />}
        //                     emptyIcon={<StarOutline style={{ color: '#f2b407' }} />}
        //                     // onChange={(e, value) => setFieldValue(name, value)}
        //                     // onChangeActive={(e, v) => setHover(v >= 0 ? v : null)}
        //                     max={5}
        //                     readOnly={true}
        //                 />

        //                 <div>({n_reviews})</div>
        //             </div>
        //         )
        //     },
        //     disableFilters: true
        // },
        {
            Header: 'Pulses score',
            accessor: `total_pulses_score`,
            disableFilters: true
        },
        {
            Header: 'Available',
            id: 'is_available_str',
            accessor: 'is_available_str',
            disableFilters: true,
            Cell: ({ cell }) => {
                return !cell.value ? 'N/A' : <Chip size="small" className={`chip-${cell.value.toLowerCase() === "yes" ? `green` : `red`}`} label={cell.value.toLowerCase() === "yes" ? `Yes` : `No`} />
            }
        },
        ...(isReadOnly ? [] : [{
            Header: "Actions",
            Filter: ``,
            Cell: ({ cell }) => {
                let { id, uid } = cell.row.original
                return (
                    <div className="is-flex aic">
                        {/* <Button className="stllr-btn btn-sm primary bordered mr-5" text="DETAILS" /> */}
                        <a className="stllr-btn btn-sm secondary bordered is-flex aic jcc" style={{ padding: "0px 8px" }} href={`/edit-expert/${id}`}>EDIT</a>
                        {/* <a className="stllr-btn btn-sm secondary bordered is-flex aic jcc ml-10" style={{ padding: "0px 8px" }} href={`/chat-expert/${id}`}>CHAT</a> */}
                        <Button className="stllr-btn btn-sm secondary bordered is-flex aic jcc ml-10" text="Chat" style={{ padding: "0px 8px" }} disabled={isStartingchat} onClick={() => startChat(id)} />
                        <a className="stllr-btn btn-sm secondary bordered is-flex aic jcc ml-10" style={{ padding: "0px 8px" }} href={`/score-expert/${id}`}>SCORE</a>
                        <a className="stllr-btn btn-sm secondary bordered is-flex aic jcc ml-10" style={{ padding: "0px 8px" }} target="_blank" href={`${process.env.REACT_APP_STLLR_URL}profile/${uid}`}>VIEW PROFILE</a>
                        <a className="stllr-btn btn-sm secondary bordered is-flex aic jcc ml-10" style={{ padding: "0px 8px" }} href={`/application/${id}`}>VIEW APPLICATION</a>
                        <a className="stllr-btn btn-sm secondary bordered is-flex aic jcc ml-10" style={{ padding: "0px 8px" }} href={`/warnings/${id}`}>Warnings</a>
                        {/* <Button className="stllr-btn btn-sm secondary bordered is-flex aic jcc ml-10" text="ADD MONEY" style={{ padding: "0px 8px" }} onClick={() => setSendMoneyModalOpen(id)} /> */}
                    </div>
                )
            }
        }])
    ], [serviceOptions, countries, niches, cities, handleCountryChange, isReadOnly])

    const { mutate: fetch, isLoading } = useMutation(params => fetchAllExperts(null, params), {
        onSuccess: ({ experts }) => {
            setExperts(experts.data)
            setTotal(experts.total)
            if (experts.pageCount !== pageCount) {
                setPageCount(experts.pageCount)
            }
        }
    })

    //console.log('experts', experts)

    const { mutate: startChat, isLoading: isStartingchat } = useMutation(expertId => chatWithExpert({ expertId }), {
        onSuccess: data => {
            if (data && !isStartingchat)
                window.location.href = `/chats-admin/${data.chat_uid}`
        },
        onError: error => {
            alert(error.data?.message, 'error')
        }
    })

    const handleRefetchData = useCallback(
        ({ pageIndex, pageSize, search, export: exportColumns }) => {
            if (user.email == process.env.REACT_APP_NOUR_ADMIN_EMAIL) search.country = 'Egypt'
            fetch({
                pageIndex,
                pageSize,
                search: { services: 'User generated content', date_add_sort: 'DESC', ...search },
                export: exportColumns
            })
        },
        []
    )

    return (
        <Container spacing={1} maxWidth='xl'>
            <Grid item lg={12}>
                <div className="is-flex aic jcsb">
                    <h2 className="mt-0 mb-5 mt-20">UGC Creators (<i>{total}</i>)</h2>
                    <div className="is-flex aic">
                        <Button className="stllr-btn btn-sm secondary bordered is-flex aic jcc" text="Top Earners" style={{ padding: "0px 8px" }} disabled={false} onClick={() => setTopEarnersModalOpen(true)} />
                        {!isReadOnly && (
                            <Button className="stllr-btn btn-sm secondary bordered is-flex aic jcc ml-10" text="Create agency user" style={{ padding: "0px 8px" }} disabled={false} onClick={() => setAgencyModalOpen(true)} />
                        )}
                    </div>
                </div>

                <TableContainerServerSide
                    name='experts'
                    paging={true}
                    columns={columns}
                    hiddenColumns={['uid']}
                    data={experts}
                    hasFilters={true}
                    allowSorting={true}
                    loading={isLoading}
                    pageCount={pageCount}
                    fetchData={handleRefetchData}
                    dataFetcher={(params) => fetchAllExperts(null, params)}
                    withExport={true}
                />
            </Grid>
            <AddAgencyModal isOpen={agencyModalOpen} onClose={() => setAgencyModalOpen(false)} />
            <SendMoneyModal expertId={sendMoneyModalOpen} onClose={() => setSendMoneyModalOpen(false)} />
            <TopEarnersModal isOpen={topEarnersModalOpen} onClose={() => setTopEarnersModalOpen(false)} />
        </Container>
    )
}

export default Ugc